import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { setting } from '../../../../setting';
import CssFilterConverter from 'css-filter-converter';
import { Router } from '@angular/router';
import { CarouselBreakpoint } from 'app/shared/utils/infinite-carousel';

@Component({
  selector: 'usb-shortcuts',
  templateUrl: './shortcuts.component.html',
  styleUrls: ['./shortcuts.component.scss']
})
export class ShortcutsComponent implements OnInit {
  @ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;

  // Mismos tramos que el "responsive" de owl que reemplaza (0→1, 400→2, 740→3, 940→4, 1140→8),
  // para conservar la misma cantidad de logos visibles por ancho de pantalla. La mecánica del
  // carrusel (autoplay, flechas, breakpoints) ahora vive en <usb-carousel> (ver template).
  carouselBreakpoints: CarouselBreakpoint[] = [
    { minWidth: 0, items: 1 },
    { minWidth: 400, items: 2 },
    { minWidth: 740, items: 3 },
    { minWidth: 940, items: 4 },
    { minWidth: 1140, items: 8 }
  ];

  public getClientsSettingAppBooking: any;
  public sectionShortcuts: any;
	public routeUploadFile:any;
  public images:any = [];
  public iconSVG4: string = '';
  public filter?: any;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private router: Router,
  ) {
    this.getClientsSettingAppBooking =  JSON.parse((localStorage.getItem(setting.name)));
    this.sectionShortcuts  = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_shortcuts);
    this.routeUploadFile =  setting.routeUploadFile;
    //console.log("llegando al shortcuts component", this.getClientsSettingAppBooking);
   // console.log("llegando al shortcuts component image", this.routeUploadFile+this.sectionShortcuts?.info[0].image);
    this.matIconRegistry.addSvgIcon(
      "star",
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.routeUploadFile+this.sectionShortcuts?.info[0].image)
    );
  }

  ngOnInit() {
    for (let index = 0; index < this.sectionShortcuts?.shortcuts_carousel.length; index++) {
      this.images[index] = this.routeUploadFile + this.sectionShortcuts?.shortcuts_carousel[index];
    }
    this.sectionShortcuts  = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_shortcuts);
    this.routeUploadFile =  setting.routeUploadFile;
    this.applyImageFilter();
   // console.log(this.images)
  }

   // Aplica un filtro de css al elemento de imagen utilizando el color seteado por cliente.
   applyImageFilter() {
    const color = '#ffffff';
    const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

    //Extraemos el literal en String de la conversión
    const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

    // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
    const colorRegex = /color\((.*)\)/;
    const colorMatch = tempFilterStr.match(colorRegex);
    const colorFilter = colorMatch ? colorMatch[1] : "";

    this.filter = colorFilter;

    // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
    setTimeout(() => {
      this.icons.forEach((icon, index) => {
          icon.nativeElement.setAttribute('style', `filter: ${this.filter};width: 45px;`)
      });
     // console.log(this.filter);
    }, 100);
  }


  /**
* Método para redirigir a una página de gestión específica según la opción proporcionada.
*
* Este método redirige al usuario a una ruta de gestión específica basada en la opción proporcionada.
*
* @mannagementOption-> Opción de gestión que define a qué ruta se debe redirigir al usuario.
*/
mannagementRedirect(mannagementOption: any, typeOption: number) {
  switch(typeOption) {
    case 1:
      this.router.navigate([`mannagement/${mannagementOption}`]);
      break;
    case 2:
      this.router.navigate([`shortCutsMannager/${mannagementOption}`]);
      break;
  }

}

}
